import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { loginSucess } from './redux/user/actions';
import axios, { refreshAccessToken, AuthHelper } from './api/axios';

const AuthLoader = ({ children }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const isAccessTokenValid = (token) => {
        if (!token) return false;

        try {
            const decoded = jwtDecode(token);
            const now = Date.now() / 1000;
            return decoded.exp >= now;
        } catch (err) {
            console.log("Invalid token format:", err);
            return false;
        }
    };

    const loadUserData = async () => {
        let token = localStorage.getItem("authToken");
        const email = localStorage.getItem("email");
        const refreshToken = localStorage.getItem("refreshToken");

        if (!token || !email) {
            setLoading(false);
            return;
        }

        if (!isAccessTokenValid(token)) {
            if (!refreshToken) {
                AuthHelper.clearAuthData();
                setLoading(false);
                return;
            }

            try {
                token = await refreshAccessToken();
            } catch (error) {
                console.log("AuthLoader: Failed to refresh token", error);
                AuthHelper.redirectToLogin();
                setLoading(false);
                return;
            }
        }

        try {
            const response = await axios.get(`admin-user-management?email=${email}`);

            const userData = response.data.data.dbResponse;

            dispatch(
                loginSucess({
                    token,
                    userId: userData?._id,
                    userRole: response?.data?.data?.user?.role,
                    user: userData,
                    email: userData?.email || email,
                    access: userData?.access,
                })
            );
        } catch (error) {
            console.log("AuthLoader: Failed to load user data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadUserData();
    }, []);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f5f5f5'
            }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading your session...</p>
                </div>
            </div>
        );
    }

    return children;
};

export default AuthLoader;
